<template>
  <div class="trf-card-info">
    <div>
      <h4 class="pb-1">{{ titulo }}</h4>
    </div>
    <slot name="card-body">
      <p class="card-body">
        {{ mensagem }}
      </p>
    </slot>
  </div>
</template>

<script>
export default {
  name: "TrfCardInfo",
  props: {
    titulo: String,
    mensagem: String,
  },
};
</script>

<style lang="scss" scoped>
.trf-card-info h4,
.card-body strong,
p.card-body {
  font-size: 12px;
  color: #31708f;
}

.trf-card-info h4 {
  font-size: 14px;
}

.trf-card-info {
  padding: 5px 15px;
  margin-bottom: 15px;
  border: 1px solid transparent;
  border-radius: 4px;
  color: #31708f;
  background-color: #d9edf7;
  border-color: #bce8f1;
}
</style>
